//to add Lead

export const ADD_LEAD_START = "ADD_LEAD_START"
export const ADD_LEAD_SUCCESS = "ADD_LEAD_SUCCESS"
export const ADD_LEAD_FAILURE = "ADD_LEAD_FAILURE"
export const ADD_LEAD_RESET = "ADD_LEAD_RESET"

// Blocked leads
export const GET_BLOCKED_LEAD_START = "GET_BLOCKED_LEAD_START"
export const GET_BLOCKED_LEAD_SUCCESS = "GET_BLOCKED_LEAD_SUCCESS"
export const GET_BLOCKED_LEAD_FAILURE = "GET_BLOCKED_LEAD_FAILURE"
export const GET_BLOCKED_LEAD_RESET = "GET_BLOCKED_LEAD_RESET"

// to get Lead

export const GET_LEAD_START = "GET_LEAD_START"
export const GET_LEAD_SUCCESS = "GET_LEAD_SUCCESS"
export const GET_LEAD_FAILURE = "GET_LEAD_FAILURE"
export const GET_LEAD_RESET = "GET_LEAD_RESET"

// to delete Lead

export const DELETE_LEAD_START = "DELETE_LEAD_START"
export const DELETE_LEAD_SUCCESS = "DELETE_LEAD_SUCCESS"
export const DELETE_LEAD_FAILURE = "DELETE_LEAD_FAILURE"
export const DELETE_LEAD_RESET = "DELETE_LEAD_RESET"

// to edit lead
export const EDIT_LEAD_START = "EDIT_LEAD_START"
export const EDIT_LEAD_SUCCESS = "EDIT_LEAD_SUCCESS"
export const EDIT_LEAD_FAILURE = "EDIT_LEAD_FAILURE"
export const EDIT_LEAD_RESET = "EDIT_LEAD_RESET"

//view-lead
export const VIEW_LEAD_START = "VIEW_LEAD_START"
export const VIEW_LEAD_SUCCESS = "VIEW_LEAD_SUCCESS"
export const VIEW_LEAD_FAILURE = "VIEW_LEAD_FAILURE"
export const VIEW_LEAD_RESET = "VIEW_LEAD_RESET"

//create-lead log

export const CREATE_LEADLOG_START = "CREATE_LEADLOG_START"
export const CREATE_LEADLOG_SUCCESS = "CREATE_LEADLOG_SUCCESS"
export const CREATE_LEADLOG_FAILURE = "CREATE_LEADLOG_FAILURE"
export const CREATE_LEADLOG_RESET = "CREATE_LEADLOG_RESET"

//Convert Leads to customer

export const CONVERT_LEAD_START = "CONVERT_LEAD_START"
export const CONVERT_LEAD_SUCCESS = "CONVERT_LEAD_SUCCESS"
export const CONVERT_LEAD_ERROR = "CONVERT_LEAD_ERROR"
export const CONVERT_LEAD_RESET = "CONVERT_LEAD_RESET"

//close-lead
export const CLOSE_LEAD_START = "CLOSE_LEAD_START"
export const CLOSE_LEAD_SUCCESS = "CLOSE_LEAD_SUCCESS"
export const CLOSE_LEAD_FAILURE = "CLOSE_LEAD_FAILURE"
export const CLOSE_LEAD_RESET = "CLOSE_LEAD_RESET"

//get closing lead reason
export const GET_CLOSELEAD_REASON_START = "GET_CLOSELEAD_REASON_START"
export const GET_CLOSELEAD_REASON_SUCCESS = "GET_CLOSELEAD_REASON_SUCCESS"
export const GET_CLOSELEAD_REASON_FAILURE = "GET_CLOSELEAD_REASON_FAILURE"
export const GET_CLOSELEAD_REASON_RESET = "GET_CLOSELEAD_REASON_RESET"
